import { render } from "./ApplicationConsent.vue?vue&type=template&id=0376754a"
import script from "./ApplicationConsent.vue?vue&type=script&lang=js"
export * from "./ApplicationConsent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__